import './EmailConfirm.scss';

import { Button } from 'antd';
import type { ApiError } from 'common/models';
import { useConfirmEmailQuery } from 'common/queries';
import { ErrorAlert, QueryErrorAlert } from 'components';
import { PublicPage } from 'components/Layout';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';
import { Link, useParams } from 'react-router-dom';

type RouteParams = 'userId' | 'token';

const EmailConfirm: React.FC = (): React.ReactElement => {
  const { t } = useCustomTranslation();
  const params = useParams<RouteParams>();

  const confirmEmailQuery = useConfirmEmailQuery(params.userId || '', params.token || '');

  const renderContent = () => {
    if (confirmEmailQuery.isSuccess) {
      return (
        <>
          <div className="EmailConfirm_info">{t('emailConfirm.successText')}</div>
          <Link to="/">
            <Button type="primary" className="public-btn">
              {t('emailConfirm.continueButton')}
            </Button>
          </Link>
        </>
      );
    }

    return <div className="EmailConfirm_info">{t('emailConfirm.progressText')}</div>;
  };

  const renderError = (error: ApiError) => {
    if (error.response?.status === 404) {
      return <ErrorAlert errorCode="emailLinkExpired" newTranslate />;
    }

    return <QueryErrorAlert error={error} onRetry={() => confirmEmailQuery.refetch()} />;
  };

  return (
    <PublicPage className="EmailConfirm" title={t('emailConfirm.title')}>
      <div className="EmailConfirm_content white-box">
        {confirmEmailQuery.error ? renderError(confirmEmailQuery.error) : renderContent()}
      </div>
    </PublicPage>
  );
};

export default EmailConfirm;
